export const WIDGET_SPACING_OPTIONS = ['compact', 'standard', 'relaxed'];

export const WIDGET_SPACING_VALUES = {
  compact: { vertical: 12, horizontal: 12 },
  standard: { vertical: 20, horizontal: 20 },
  relaxed: { vertical: 32, horizontal: 32 },
};

export const getWidgetSpacingPixels = (spacing, axis) => {
  const values =
    WIDGET_SPACING_VALUES[spacing] || WIDGET_SPACING_VALUES.standard;
  return values[axis];
};
